import { useQuery } from '@tanstack/react-query';

import { getUnreadNotificationsCount } from '../api/notifications.api';

interface UseUnreadNotificationsCountParams {
  /** Enable or disable the query */
  enabled?: boolean;
}

/**
 * Hook for fetching the count of unread notifications.
 * Count will be updated via FCM silent pushes instead of periodic refetching.
 */
export const useUnreadNotificationsCount = ({
  enabled = true,
}: UseUnreadNotificationsCountParams = {}) => {
  const {
    data: count = 0,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: getUnreadNotificationsCount,
    enabled,
    // No refetchInterval - will be updated via FCM silent pushes
  });

  return {
    count,
    isLoading,
    error: error as Error | null,
    refetch,
  };
};
